(() => {
  const initialize = (section) => {
    if (!section || section.dataset.viviereInitialized === 'true') return;
    section.dataset.viviereInitialized = 'true';

    const slides = Array.from(section.querySelectorAll('[data-viviere-slide]'));
    const previousButton = section.querySelector('[data-viviere-prev]');
    const nextButton = section.querySelector('[data-viviere-next]');
    const variantInputs = Array.from(section.querySelectorAll('[data-viviere-variant]'));
    const variantIdInput = section.querySelector('[data-viviere-variant-id]');
    const buttonPrice = section.querySelector('[data-viviere-button-price]');
    const buyNowButton = section.querySelector('[data-viviere-buy-now]');
    const errorMessage = section.querySelector('[data-viviere-error]');
    let activeIndex = Math.max(0, slides.findIndex((slide) => !slide.hidden));

    const showSlide = (index) => {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
    };

    previousButton?.addEventListener('click', () => showSlide(activeIndex - 1));
    nextButton?.addEventListener('click', () => showSlide(activeIndex + 1));

    variantInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        if (variantIdInput) variantIdInput.value = input.value;
        if (buttonPrice && input.dataset.price) buttonPrice.textContent = input.dataset.price;

        const imageId = input.dataset.imageId;
        if (imageId) {
          const imageIndex = slides.findIndex((slide) => slide.dataset.imageId === imageId);
          if (imageIndex >= 0) showSlide(imageIndex);
        }
      });
    });

    buyNowButton?.addEventListener('click', async () => {
      if (!variantIdInput?.value) return;
      const root = window.Shopify?.routes?.root || '/';
      const originalText = buyNowButton.textContent;
      buyNowButton.disabled = true;
      buyNowButton.textContent = 'LOADING...';
      if (errorMessage) errorMessage.hidden = true;

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantIdInput.value),
                quantity: 1,
              },
            ],
          }),
        });

        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || 'The product could not be added.');
        }

        window.location.assign('/checkout');
      } catch (error) {
        buyNowButton.disabled = false;
        buyNowButton.textContent = originalText;
        if (errorMessage) {
          errorMessage.textContent = error.message;
          errorMessage.hidden = false;
        }
      }
    });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-viviere-product]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();